import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';


/**
 * entry point
 */
export const init = () => {
    const $root = document.getElementById('search-bar-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        $root
    );
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});